export default "<template>\n\n  <KLogo\n    altText=\"Kolibri logo\"\n    :size=\"120\"\n  />\n\n</template>\n";